import { ViewPDFComplaint } from "../../services/denunciasApi";
import { formatDateForFormDenuncia, formatTimeForFormDenuncia } from "../../helpers/dateFormat";


export const VerPDF = (jsonData) => async () => {
  try {
    const data = mapDataPDF(jsonData);
    const request = await ViewPDFComplaint(data);
    const doc = await request.blob();
    showFile(doc);
  } catch (e) {
    console.error(e);
  }
};

const mapDataPDF = (jsonData) => ({
  ACCIDENTADO: {
    APE_PATERNO: jsonData.formInfoTrabajador.LastName,
    APE_MATERNO: jsonData.formInfoTrabajador.MothersName,
    NOMBRES: jsonData.formInfoTrabajador.FirstName,
    RUT: jsonData.formInfoTrabajador.Rut,
    FEC_NAC: jsonData.formInfoTrabajador.Birthdate,
    SEXO: jsonData.formInfoTrabajador.Sexo.Sexo,
    NACIONALIDAD: jsonData.formInfoTrabajador.Nacionalidad.Nacionalidad,
    TIPO_CALLE: jsonData.formInfoTrabajador.TipoCalle.TipoCalle,
    NOMBRE_CALLE: jsonData.formInfoTrabajador.Calle,
    NUMERO_CALLE: jsonData.formInfoTrabajador.Numero,
    POBLACION: jsonData.formInfoTrabajador.Poblacion,
    REGION: jsonData.formInfoTrabajador.Region.Region,
    COMUNA: jsonData.formInfoTrabajador.Comuna.DescripcionCommuna,
    CIUDAD: jsonData.formInfoTrabajador.Ciudad.DescripcionCiudad,
    AREA: jsonData.formInfoTrabajador.Code,
    NUMERO_TELEFONO: jsonData.formInfoTrabajador.Phone,
    CANT_ANTIGUEDAD: jsonData.formInfoTrabajador.Antiguedad,
    TIPO_ANTIGUEDAD: "Días",
    GRP_ETNICO: jsonData.formInfoTrabajador.PuebloOriginario.PuebloOriginario,
    CAT_OCUPACION: jsonData.formInfoTrabajador.CategoriaOcupacional.CategoriaOcupacional,
    TIPO_INGRESO: jsonData.formInfoTrabajador.TipoIngreso.TipoIngreso,
    TIPO_CONTRATO: jsonData.formInfoTrabajador.TipoContrato.TipoContrato,
    COD_PROFESION: jsonData.formInfoTrabajador.ProfesionOficio.Ocupacion,
  },
  DENUNCIA: {
    FEC_DENUNCIA: formatDateForFormDenuncia(jsonData.horaPresentacion),
    HORA_DENUNCIA: formatTimeForFormDenuncia(jsonData.horaPresentacion),
  },
  ACCIDENTE: jsonData.formInfoDenuncia.tipoDenuncia.IdTipoDenuncia === "004" ? {
    TIPO_CALLE: "",
    NOMBRE_CALLE: "",
    NUMERO_CALLE: "",
    POBLACION: "",
    REGION: "",
    COMUNA: "",
    CIUDAD: "",
    SITIO_PRECISO: "",
    ACT_ANTES_ACCIDENTE: "",
    REA_TRAB_HABITUAL: "",
    FEC_ACC: "",
    HORA_ACC: "",
    HORA_ING_TRABAJO: "",
    HORA_SAL_TRABAJO: "",
    TEXTO_TRAB_HAB: "",
    CLS_ACCIDENTE: "",
    TIPO_ACCIDENTE: "",
    TIPO_ACC_T: "",
    DETALLE: "",
  } : {
      TIPO_CALLE: jsonData.formDatoSiniestro.TipoCalle.TipoCalle,
      NOMBRE_CALLE: jsonData.formDatoSiniestro.Calle,
      NUMERO_CALLE: jsonData.formDatoSiniestro.Numero,
      POBLACION: jsonData.formDatoSiniestro.Poblacion,
      REGION: jsonData.formDatoSiniestro.Region.Region,
      COMUNA: jsonData.formDatoSiniestro.Comuna.DescripcionCommuna,
      CIUDAD: jsonData.formDatoSiniestro.Ciudad.DescripcionCiudad,
      SITIO_PRECISO: jsonData.formDatoSiniestro.SitioAccidente,
      ACT_ANTES_ACCIDENTE: jsonData.formDatoSiniestro.ActividadAntesAccidente,
      REA_TRAB_HABITUAL: jsonData.formDatoSiniestro.RealizabaSuTrabajo === "X" ? "Sí" : "No",
      FEC_ACC: formatDateForFormDenuncia(jsonData.formDatoSiniestro.FechaHoraAccidente),
      HORA_ACC: formatTimeForFormDenuncia(jsonData.formDatoSiniestro.FechaHoraAccidente),
      HORA_ING_TRABAJO: formatTimeForFormDenuncia(jsonData.formInfoTrabajador.HoraIngreso),
      HORA_SAL_TRABAJO: formatTimeForFormDenuncia(jsonData.formInfoTrabajador.HoraSalida),
      TEXTO_TRAB_HAB: jsonData.formDatoSiniestro.TrabajoHabitual,
      CLS_ACCIDENTE: jsonData.formDatoSiniestro.ClasificacionAccidente.ClasificacionAccidente,
      TIPO_ACCIDENTE: jsonData.formDatoSiniestro.TipoAccidente.DescripcionTipoAccidente,
      TIPO_ACC_T: jsonData.formDatoSiniestro.TipoAccidente.IdTipoAccidente === 2 ? jsonData.formDatoSiniestro.TipoAccidenteTrayecto.DescripcionTipoAccidenteTrayecto : "",
      DETALLE: jsonData.formDatoSiniestro.DetalleMedioPrueba,
    },
  DENUNCIANTE: {
    APE_PATERNO: jsonData.formDenunciante.LastName,
    APE_MATERNO: jsonData.formDenunciante.MothersName,
    NOMBRES: jsonData.formDenunciante.FirstName,
    RUT: jsonData.formDenunciante.Rut,
    AREA: jsonData.formDenunciante.Code,
    NUM_TELEFONO: jsonData.formDenunciante.Phone,
  },
  EMPLEADOR: {
    NOMBRE_EMP: jsonData.formDatosEmpresa.NombreRazon,
    RUT: jsonData.formDatosEmpresa.RutEmpresa,
    REGION: jsonData.formInfoTrabajador.RegionSucursal,
    COMUNA: jsonData.formInfoTrabajador.ComunaSucursal,
    SUCURSAL: jsonData.formInfoTrabajador.Sucursal.Direccion,
    TIPO_CALLE: jsonData.formInfoTrabajador.TipoCalleSucursal,
    NOMBRE_CALLE: jsonData.formInfoTrabajador.NombreCalleSucursal,
    NUMERO_CALLE: jsonData.formInfoTrabajador.NumeroCalleSucursal,
    POBLACION: jsonData.formInfoTrabajador.PoblacionVillaSucursal,
    CIUDAD: jsonData.formInfoTrabajador.Sucursal.Ciudad,
    AREA: jsonData.formInfoTrabajador.SucursalCode,
    NUMERO_TELEFONO: jsonData.formInfoTrabajador.SucursalPhone,
    TOTAL_TRAB_HOMBRE: jsonData.formDatosEmpresa.TotalHombres,
    TOTAL_TRAB_MUJER: jsonData.formDatosEmpresa.TotalMujeres,
    COD_ACT_ECONOMICA: jsonData.formDatosEmpresa.Actividad.DescripcionActividadEconomica,
    PRO_EMPRESA: jsonData.formDatosEmpresa.Propiedad.DescripcionPropiedadEmpresa,
    TIPO_EMPRESA: jsonData.formDatosEmpresa.TipoEmpresa.DescripcionTipoEmpresa,
    COD_ACT_ECON_PPAL: jsonData.formDatosEmpresa.ActividadPrincipal ? jsonData.formDatosEmpresa.ActividadPrincipal.DescripcionActividadEconomica : "",
  },
  ENFERMEDAD: jsonData.formInfoDenuncia.tipoDenuncia.IdTipoDenuncia === "004" ? {
    DESC_SINTOMASDESC_SINTOMAS: jsonData.formDatosEnfermedad.DescripcionSintomas,
    FEC_INI_SINT: formatDateForFormDenuncia(jsonData.formDatosEnfermedad.FechaInicioSintomas),
    PARTE_CUERPO: jsonData.formDatosEnfermedad.PartesCuerpo,
    CUADRO_PREVIO: jsonData.formDatosEnfermedad.CuadroPrevio === "X" ? "Sí" : "No",
    TRAB_REALIZABA: jsonData.formDatosEnfermedad.DescripcionTrabajo,
    PUESTO_TRABAJO: jsonData.formDatosEnfermedad.NombrePuesto,
    EXIS_COMP_SINTOMAS: jsonData.formDatosEnfermedad.ExistenCompanerosSintomas === "X" ? "Sí" : "No",
    AGEN_SOSPECHOSO: jsonData.formDatosEnfermedad.Agente,
    FEC_EXP_AGENTE: formatDateForFormDenuncia(jsonData.formDatosEnfermedad.FechaPrimeraExposicion),
  } : {
      DESC_SINTOMASDESC_SINTOMAS: "",
      FEC_INI_SINT: "",
      PARTE_CUERPO: "",
      CUADRO_PREVIO: "",
      TRAB_REALIZABA: "",
      PUESTO_TRABAJO: "",
      EXIS_COMP_SINTOMAS: "",
      AGEN_SOSPECHOSO: "",
      FEC_EXP_AGENTE: "",
    },
  MEDIO_PRUEBA: jsonData.formInfoDenuncia.tipoDenuncia.IdTipoDenuncia !== "004" ? {
    DECLARACION: jsonData.formDatoSiniestro.AlMomentoDelAccidente, // Validar si hay que componer la redacción según datos recopilados
    DETALLE: jsonData.formDatoSiniestro.DetalleMedioPrueba,
    PARTE_CARABINEROS: jsonData.formDatoSiniestro.MedioPrueba.Codigo === "1" ? "Sí" : "No",
    TESTIGOS: jsonData.formDatoSiniestro.Testigos === "X" ? "Sí" : "No",
    OTRO: jsonData.formDatoSiniestro.MedioPrueba.Codigo === "4" ? "Sí" : "No",
  } : {
      DECLARACION: "",
      DETALLE: "",
      PARTE_CARABINEROS: "",
      TESTIGOS: "",
      OTRO: "",
    },
});

export const showFile = (blob) => {
  const newBlob = new Blob([blob], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(newBlob);
  window.open(fileURL);
};

